/**
 * Error, that should not be tracked, handled in any scope
 */
import { PresentableError } from './PresentableError';

export class WidgetPresentableError extends PresentableError {
    constructor(...args) {
        super(...args);
        this.name = 'WidgetPresentableError';
    }
}
